'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MinusCircled = require('./MinusCircled');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MinusCircled).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/MinusCircled/index.js
// module id = 1234
// module chunks = 1